import { Auth } from 'aws-amplify';
import { getRealEstateIdBasedOnURL } from 'utils/real-estate-config';

export function loginEmailAPI(email, password) {
  return Auth.signIn({
    username: email, 
    password: password,
    validationData: { realEstateId: getRealEstateIdBasedOnURL() },
  });
}